module.exports = __webpack_public_path__ + "img/1970East-035_WEB-min.b6196455.jpg";